import axios from "axios";
import { API_BASE_URL } from '../../config/apiConfig';

// ==============================================
// SPPO CLOSE VERIFICATION RELATED APIs
// ==============================================

// 1. Get SPPO Close Verification Grid by Role ID, User ID and Type
export const getVerificationSPPOClose = async (roleId, userId, type) => {
    try {
        
        const response = await axios.get(
            `${API_BASE_URL}/Purchase/GetVerificationSPPOClose?Roleid=${roleId}&Userid=${userId}&Type=${type}`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 2. Get SPPO Details by SPPO Number, CC Code and Vendor Code
export const getSPPObyNo = async (sppoNo, ccCode, vendorCode) => {
    try {
        
        const response = await axios.get(
            `${API_BASE_URL}/Purchase/GetSPPObyNo?Sppono=${sppoNo}&CCCode=${ccCode}&VendorCode=${vendorCode}`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 3. Approve Close SPPO
export const approveCloseSPPO = async (approvalData) => {
    try {
        
        const response = await axios.put(
            `${API_BASE_URL}/Purchase/ApproveCloseSPPO`,
            approvalData,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                timeout: 30000
            }
        );
        
        return response.data;
        
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};